import { isomorphicHttpClient } from "../httpClient";

export const getSession = async () => {
  const httpClient = isomorphicHttpClient();

  const { data, error } = await httpClient.GET("/v1/users/me");

  return { data, error };
};
